<template>
  <div class="product-content">
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <div class="menu">
      <div class="menu-lsit">
        <p class="menu-lsit-item" :class="menuIndex == index ? 'menu-lsit-item_' : ''" v-for="(item, index) in menuList"
          :key="index" @click="getTopMenu(item.id, index)">
          {{ item.name }}
        </p>
      </div>
    </div>
    <div class="select-class">
      <div>选择分类</div>
      <div>
        <i class="el-icon-right" style="font-size:30px" @click="getSelect"></i>
      </div>
    </div>
    <div class="menu-mask" v-if="isMenu">
      <div class="clone-mask">
        <i class="el-icon-back" style="font-size:30px" @click="getCloneSelect"></i>
        <div class="clone-mask-name"> 返回产品列表 </div>
      </div>
      <div class="productMenu-list" v-for="(item, index) in productMenu" :key="index" @click.stop="getMenu(index)">
        <div class="productMenu-item" :class="item.isChack ? 'cur' : ''"
          :style="(!item.isChack && index != productMenu.length - 1) || item.childlist.length == 0 ? 'border-bottom:none !important;' : ''">
          {{ item.name }}
          <img class="productMenu-item-icon" v-if="item.childlist.length > 0"
            :src="item.isChack ? '../../../static/image/chack.png' : '../../../static/image/ischack.png'" alt="">
        </div>
        <div class="productMenu-list-item" v-if="item.isChack && item.childlist.length > 0">
          <div class="productMenu-list-item-items" :class="items.id == channel ? 'cur' : ''"
            v-for="(items, indexs) in item.childlist" :key="indexs" @click.stop="getChildTap(items.id)">
            {{ items.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="product-content-box">
            <div class="left">
              <div class="productMenu-list" v-for="(item, index) in productMenu" :key="index"
                @click.stop="getMenu(index)">
                <div class="productMenu-item" :class="item.isChack ? 'cur' : ''"
                  :style="(!item.isChack && index != productMenu.length - 1) || item.childlist.length == 0 ? 'border-bottom:none !important;' : ''">
                  {{ item.name }}
                  <img class="productMenu-item-icon" v-if="item.childlist.length > 0"
                    :src="item.isChack ? '../../../static/image/chack.png' : '../../../static/image/ischack.png'" alt="">
                </div>
                <div class="productMenu-list-item" v-if="item.isChack && item.childlist.length > 0">
                  <div class="productMenu-list-item-items" :class="items.id == channel ? 'cur' : ''"
                    v-for="(items, indexs) in item.childlist" :key="indexs" @click.stop="getChildTap(items.id)">
                    {{ items.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="right" :style="productMenu.length > 0 ? '' : 'width:100% !important'">
              <div class="product-lsit" v-for="(item, index) in productList " :key="index" @click="getDetails(item)">
                <div class="item-image-box product-image">
                  <img class="images" :src="item.image" alt="">
                </div>
                <div class="item-title">{{ item.title }}</div>
                <div class="item-content">{{ item.description }}</div>
                <div class="product-lsit-button">
                  <i class="el-icon-top-right" color="#FFFFFF"></i> More
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="block pagination">
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="pageSize" :total="total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { divisionMenu, divisionList, nav } from '@/request/api';
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      menuList: [],
      productMenu: [],
      menuIndex: 0,
      productList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      channel: "",
      swiperImage: "",
      productIndex: 0,
      isMenu: false
    }
  },
  created() {
    this.getNav()
    this.getMenuList()
  },
  mounted() {
    this.getParams();
  },
  watch: {
    '$route'(){
     this.getParams();
    }
  },
  methods: {
    getParams() {
      if (this.$route.query.type) {
        this.menuIndex = this.$route.query.type
      }
    },
    getNav() {
      nav({}).then(res => {
        this.swiperImage = res.data[2].image
      })
    },
    getMenuList() {
      let that = this
      divisionMenu().then(res => {
        if (res.code == 1) {
          this.menuList = res.data
          for (let j = 0; j < res.data[that.menuIndex].childlist.length; j++) {
            res.data[that.menuIndex].childlist[j].isChack = false
          }
          if (res.data[that.menuIndex].childlist.length > 0) {
            res.data[that.menuIndex].childlist[0].isChack = true
          }
          that.channel = res.data[that.menuIndex].childlist.length > 0 ? res.data[that.menuIndex].childlist[0].id : res.data[that.menuIndex].id
          that.productMenu = res.data[that.menuIndex].childlist
          that.getList()
        }
      })
    },
    getList() {
      divisionList({ page: this.page, pageSize: this.pageSize, channel: this.channel }).then(res => {
        if (res.code == 1) {
          this.total = res.data.total
          this.productList = res.data.list
        }
      })
    },
    handleSizeChange() { },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getChildTap(id) {
      if (this.channel == id) {
        return
      }
      this.isMenu = false
      this.page = 1
      this.channel = id
      this.getList()
    },
    getMenu(index) {
      let that = this
      if (that.productMenu[index].childlist.length > 0) {
        that.productMenu[index].isChack = !that.productMenu[index].isChack
      } else {
        for (let i = 0; i < that.productMenu.length; i++) {
          that.productMenu[i].isChack = false
          if (index == i) {
            that.productMenu[i].isChack = true
            that.channel = that.productMenu[i].id
          }
        }
        this.isMenu = false
        this.productList = []
        this.page = 1
        this.getList()

      }
      that.productIndex++
    },
    getDetails(item) {
      this.$router.push({
        path: '/productDetails',
        query: {
          channel: this.channel,
          productId: item.id,
        }
      })
    },
    getTopMenu(id, index) {
      this.productList = []
      this.menuIndex = index
      for (let j = 1; j < this.menuList[index].childlist.length; j++) {
        this.menuList[index].childlist[j].isChack = false
      }
      if (this.menuList[index].childlist.length > 0) {
        this.menuList[index].childlist[0].isChack = true
        this.channel = this.menuList[index].childlist[0].id
      } else {
        this.channel = this.menuList[index].id
      }
      this.productMenu = this.menuList[index].childlist
      this.page = 1
      this.getList()
    },
    getSelect() {
      this.isMenu = true
    },
    getCloneSelect() {
      this.isMenu = false
    }
  },
}
</script>
<style lang="scss" scoped>
.menu {
  height: 57px;
  background: #131823;

}

.menu-lsit {
  display: flex;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  justify-content: center;


}

.menu-lsit-item {
  display: block;
  text-align: center;
  width: 164px;
  height: 57px;
  line-height: 57px;
  font-size: 16px;

  color: #FFFFFF !important;
  cursor: pointer;
}

.menu-lsit-item_ {
  background: #DB2733 !important;
}

.menu-lsit-item:hover {
  background: #DB2733;
}

.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}

.select-class {
  display: none;
}

.product-content-box {
  display: flex;
  align-items: self-start;
  justify-content: space-between;

  .left {
    display: block;
    width: 15%;

    .productMenu-list {
      .productMenu-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 50px 0;
        border-top: 1px solid #DFDFDF;
        border-bottom: 1px solid #DFDFDF;

        .productMenu-item-icon {
          width: 24px;
          height: 24px;
          border-radius: 100%;
        }
      }

      .cur {
        color: #DB2733 !important;
      }

      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #333333;

      .productMenu-list-item {
        margin-top: 42px;
        text-align: left;

        .productMenu-list-item-items {
          margin-bottom: 42px;
          cursor: pointer;
          // padding: 0 30px;
          padding-left: 30px;
        }
      }
    }
  }

  .menu-mask {
    display: none;
  }

  .right {
    width: 80%;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    flex-wrap: wrap;

    .product-lsit {
      margin-right: 10px;
      margin-bottom: 70px;
      width: 338px;

      .item-image-box {
        cursor: pointer;
        width: 100%;
        height: 340px;
        background: #F7F7F7;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 263px;
          height: 263px;
          overflow: hidden;
        }
      }

      .item-title {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 21px;
        font-size: 24px;
        text-align: center;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #333333;
      }

      .item-content {
        font-size: 15px;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-top: 8px;
        text-align: center;

        color: #999999;
        line-height: 26px;
      }

      .product-lsit-button {
        cursor: pointer;
        margin: 0 auto;
        margin-top: 23px;
        width: 202px;
        height: 43px;
        text-align: center;
        line-height: 43px;
        border-radius: 29px;
        border: 2px solid #333333;
        font-size: 18px;

        color: #333333;
      }

      .product-lsit-button:hover {
        border: 2px solid #DB2733;
        background: #DB2733;
        color: #FFFFFF;
      }
    }

    .product-lsit:last-child {
      margin-right: 0px !important;
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #DB2733;
    color: #FFFF !important;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #DB2733;
  }

  /deep/ .el-input__inner:focus {
    border-color: #DB2733 !important;
  }
}

@media screen and (max-width:767px) {
  .left {
    display: none !important;
    width: 0 !important;
  }

  .right {
    width: 100% !important;
    display: block !important;

    .product-lsit {
      margin-right: 0 !important;
      width: 100% !important;
      margin-bottom: 30px !important;

      .item-image-box {
        height: 340px !important;

        img {
          width: 263px !important;
          height: 263px !important;
        }
      }

    }
  }

  .select-class {
    display: flex;
    padding: 30px 15px;
    align-items: center;
    justify-content: space-between;
  }

  .menu-mask {
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 15px;
    overflow: scroll;
    background: #FFFFFF;
    z-index: 1000;

    .clone-mask {
      // text-align: right;
      display: flex;
      align-items: center;
      padding: 16px 0;

      .clone-mask-name {
        margin-left: 5px;
      }
    }

    .productMenu-list {
      padding: 16px 0;
      border-top: 1px solid #eaeaea;
    }

    .cur {
      color: #DB2733 !important;
    }

    .productMenu-list-item {
      margin-top: 15px;

      .productMenu-list-item-items {
        // margin-top:15px;
        padding: 16px 15px;
        border-top: 1px solid #eaeaea;
      }
    }

  }
}</style>



// WEBPACK FOOTER //
// src/view/product/product.vue